<template>
  <v-container justify-center>
    <v-layout row wrap>
      <v-flex xs12 mt-5>
       <group-job-form-component :group="group" :form="form"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import GroupJobFormComponent from '../components/GroupJobForm.vue'
export default {
  name: 'CreateGroupJob',
  components: {
    GroupJobFormComponent,
  },
  data() {
    return {
      group: {
        groupId: 'Gw8vK6WaJOefZ1DYTXET',
        groupLeaderUserId: 'btr31UzuDsbELLfwHJWoHrlrOxr2'
      },
      form: {
        title: 'グループジョブ作成',
        subTitle: '同じ目的を持つメンバーと一緒にジョブを実施することができます',
        buttonText: '作成'
      }
    }
  }
}
</script>